var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-dropdown-item',{attrs:{"disabled":_vm.isLoading},on:{"click":function($event){return _vm.downloadFile()}}},[(_vm.isLoading)?_c('b-spinner',{attrs:{"label":"Spinning","small":""}}):_vm._e(),_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }